import { render, staticRenderFns } from "./CardText.vue?vue&type=template&id=5a12c339&scoped=true&"
import script from "./CardText.vue?vue&type=script&lang=js&"
export * from "./CardText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a12c339",
  null
  
)

export default component.exports